<zef-dialog
  [open]="state.open"
  [options]="{ restoreFocus: false }"
  [autoFocus]="false">
  <div class="__content  fx:relative">

    <zef-scrollbar maxHeight="80vh">

      <div class="__client-user-role-redirect-content">

        <h3 class="__title">Your role has changed!</h3>

        <p class="fx:mb-1">Your user role for current client has been changed.</p>

        <a
          mat-flat-button
          color="accent"
          (click)="reload()"
          class="c-button--full">
          Refresh the page
        </a>

      </div>

    </zef-scrollbar>

  </div>
</zef-dialog>
